/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import { IoClose } from "react-icons/io5";
import { PiFunnelBold } from "react-icons/pi";

import {
  TextField,
  Autocomplete,
  Checkbox,
  FormControlLabel,
} from "@mui/material";

import { MyModal } from "../../../../components/Common/Model/MyModal";
import ModalContainer from "../../../../components/Common/Model/ModalContainer";
import DateFilter from "../../../../components/Common/FilterComponent/DateFilter";

import styles from "./style.module.scss";
import { decryptedAdminID, expOptions, sources } from "../../../../utility";
import { useSelector } from "react-redux";
import { getpipelineReasonNames } from "../../../../services/interviewServices";
import { debounce } from "lodash";

const LeadFilterOffcanvas = ({
  filters = {},
  onApply,
  onReset,
  onClose,
  adminList = [],
  options = {},
}) => {
  const loggedId = Number(decryptedAdminID());
  const adminDetails = useSelector((state) => state.adminDetails);
  const isSuperAdmin = adminDetails.roleID == 1;
  const isTeamLeader = localStorage.getItem("teamLeader") == "true";

  const role = isSuperAdmin
    ? "superadmin"
    : isTeamLeader
      ? "teamleader"
      : "admin";

  const getDefaultAssignState = () => {
    if (role === "superadmin") return { assign_to: null, onlyMe: false };
    if (role === "teamleader") return { assign_to: loggedId, onlyMe: true };
    return { assign_to: loggedId, onlyMe: true };
  };

  const [reasonList, setReasonList] = useState([]);
  const [expType, setExpType] = useState(null);
  const [isCustomExp, setIsCustomExp] = useState(false);
  const [expand, setExpand] = useState({
    skill: false,
    location: false,
    area: false,
    job: false,
  });

  // const debouncedFetchReasons = useRef(
  //   debounce(async () => {
  //     try {
  //       const data = await getpipelineReasonNames(1);
  //       setReasonList((data || []).map((item) => ({ id: item.id, name: item.stage_name })));
  //     } catch (err) {
  //       console.log("Reason Fetch Error:", err);
  //     }
  //   }, 300),
  // ).current;

  const debouncedFetchReasons = useRef(
    debounce(async () => {
      try {
        const data = await getpipelineReasonNames(1);

        // ❌ remove unwanted ids
        // const filtered = (data || []).filter(
        //   (item) => ![2, 3, 5, 26].includes(item.id)
        // );

        // ✅ map API data
        const apiOptions = data.map((item) => ({
          id: item.id,
          name: item.stage_name,
        }));

        // ✅ manually add only 26
        const manualOption = {
          id: 26,
          name: "Not Interest",
        };

        const filtered = apiOptions.filter((i) => i.id !== 26);
setReasonList([...filtered, manualOption]);
      } catch (err) {
        console.log("Reason Fetch Error:", err);
      }
    }, 300),
  ).current;

  useEffect(() => {
    debouncedFetchReasons();
    return () => debouncedFetchReasons.cancel();
  }, []);

  const [form, setForm] = useState({
    mobile_number: "",
    first_name: "",
    job_category: [],
    source: null,
    pref_location: [],
    pref_area: [],
    exp_from: null,
    exp_to: null,
    current_stage_id: null,
    current_sub_stage_id: null,
    created_from: "",
    created_to: "",
    sub_stage_date_from: "",
    sub_stage_date_to: "",
    lead_deactive: false,
    alreadyRegister: false,
    registeredMoved: false,
    ...getDefaultAssignState(),
  });

  // ── Init from filters ──
  useEffect(() => {
    setForm((prev) => ({
      ...prev,
      mobile_number: filters.mobile_number ?? "",
      first_name: filters.first_name ?? "",
      job_category: filters.job_category ?? [],
      source: filters.source ?? null,
      pref_location: filters.pref_location ?? [],
      pref_area: filters.pref_area ?? [],
      exp_from: filters.exp_from ?? null,
      exp_to: filters.exp_to ?? null,
      current_stage_id: filters.current_stage_id ?? null,
      current_sub_stage_id: filters.current_sub_stage_id ?? null,
      created_from: filters.created_from ?? "",
      created_to: filters.created_to ?? "",
      sub_stage_date_from: filters.sub_stage_date_from ?? "",
      sub_stage_date_to: filters.sub_stage_date_to ?? "",
      lead_deactive: filters.lead_deactive ?? false,
      alreadyRegister: filters.alreadyRegister ?? false,
      registeredMoved: filters.registeredMoved ?? false,
      assign_to:
        filters.assign_to !== undefined
          ? filters.assign_to
          : getDefaultAssignState().assign_to,
      onlyMe:
        filters.onlyMe !== undefined
          ? filters.onlyMe
          : getDefaultAssignState().onlyMe,
    }));
  }, [filters]);

  // ── Experience sync ──
  useEffect(() => {
    if (!form.exp_from && !form.exp_to) {
      setExpType(null);
      setIsCustomExp(false);
      return;
    }
    const match = expOptions.find(
      (opt) =>
        Number(opt.min) === Number(form.exp_from) &&
        Number(opt.max) === Number(form.exp_to),
    );
    if (match) {
      setExpType(match);
      setIsCustomExp(false);
    } else {
      setExpType(expOptions.find((o) => o.label === "Custom"));
      setIsCustomExp(true);
    }
  }, [form.exp_from, form.exp_to]);

  const handleChange = (key, value) =>
    setForm((p) => ({ ...p, [key]: value === "" ? null : value }));

  const handleApply = () => {
    onApply({ ...form, fromSource: form.source });
    onClose();
  };

  const handleReset = () => {
    onReset();
    onClose();
  };

  // ── Options from prop (same as Registered) ──
  const jobOptions = options.jobCategory || [];
  const locationOptions = options.prefLocation || [];
  const areaOptions = options.prefArea || [];

  // ── Assign ──
  const mergedAdminList = (() => {
    const exists = adminList.some((a) => a.id === loggedId);
    if (exists) return adminList;
    return [{ id: loggedId, name: "You" }, ...adminList];
  })();

  const assignOptions = (() => {
    const memberOptions = mergedAdminList
      .filter((a) => a.id !== loggedId)
      .map((a) => ({ label: a.name, value: a.id }));

    if (role === "superadmin") {
      return [
        { label: "All", value: "all" },
        { label: "Self", value: "self" },
        ...memberOptions,
      ];
    }
    if (role === "teamleader") {
      return [
        { label: "My Team", value: "team" },
        { label: "Self", value: "self" },
        ...memberOptions,
      ];
    }
    return [];
  })();

  const assignValueObj = (() => {
    if (role === "superadmin") {
      if (form.assign_to == null && form.onlyMe === false)
        return assignOptions.find((o) => o.value === "all") || null;
      if (Number(form.assign_to) === loggedId && form.onlyMe === true)
        return assignOptions.find((o) => o.value === "self") || null;
      return (
        assignOptions.find((o) => Number(o.value) === Number(form.assign_to)) ||
        null
      );
    }
    if (role === "teamleader") {
      if (form.assign_to == null || form.onlyMe == null)
        return assignOptions.find((o) => o.value === "team") || null;
      if (Number(form.assign_to) === loggedId && form.onlyMe === true)
        return assignOptions.find((o) => o.value === "self") || null;
      if (Number(form.assign_to) === loggedId && form.onlyMe === false)
        return assignOptions.find((o) => o.value === "team") || null;
      return (
        assignOptions.find((o) => Number(o.value) === Number(form.assign_to)) ||
        null
      );
    }
    return null;
  })();

  const handleAssignChange = (_, selected) => {
    if (!selected) return;
    const val = selected.value;

    if (role === "superadmin") {
      if (val === "all")
        setForm((f) => ({ ...f, assign_to: null, onlyMe: false }));
      else if (val === "self")
        setForm((f) => ({ ...f, assign_to: loggedId, onlyMe: true }));
      else setForm((f) => ({ ...f, assign_to: Number(val), onlyMe: true }));
      return;
    }
    if (role === "teamleader") {
      if (val === "team")
        setForm((f) => ({ ...f, assign_to: loggedId, onlyMe: false }));
      else if (val === "self")
        setForm((f) => ({ ...f, assign_to: loggedId, onlyMe: true }));
      else setForm((f) => ({ ...f, assign_to: Number(val), onlyMe: true }));
      return;
    }
  };

  // ── Tag render ──
  const chipStyle = {
    background: "#e0e0e0",
    padding: "4px 8px",
    borderRadius: "16px",
    fontSize: "12px",
  };
  const moreStyle = { fontSize: "12px", cursor: "pointer" };
  const autoSX = {
    width: "100%",
    "& .MuiAutocomplete-inputRoot": {
      flexWrap: "wrap",
      alignItems: "flex-start",
      gap: "6px",
      paddingTop: "6px",
      paddingBottom: "6px",
    },
  };

  const renderTags = (value, getTagProps, type) => {
    const isExpanded = expand[type];
    const visible = isExpanded ? value : value.slice(0, 3);
    const hiddenCount = value.length - 3;
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "6px",
        }}
      >
        {visible.map((option, index) => (
          <span
            {...getTagProps({ index })}
            key={option.id || option.label}
            style={chipStyle}
          >
            {option.label}
          </span>
        ))}
        {!isExpanded && hiddenCount > 0 && (
          <span
            style={moreStyle}
            onClick={() => setExpand((p) => ({ ...p, [type]: true }))}
          >
            +{hiddenCount}
          </span>
        )}
        {isExpanded && value.length > 3 && (
          <span
            style={moreStyle}
            onClick={() => setExpand((p) => ({ ...p, [type]: false }))}
          >
            Show less
          </span>
        )}
      </div>
    );
  };

  // const selectedReason = reasonList.find((r) => r.id === form.current_sub_stage_id) || null;
  const selectedReason =
    reasonList.find(
      (r) =>
        r.id === form.current_sub_stage_id || r.id === form.current_stage_id,
    ) || null;

  return (
    <MyModal>
      <ModalContainer>
        <div>
          {/* HEADER */}
          <div className={styles.header}>
            <span className={styles.headerTitle}>
              <PiFunnelBold size={16} /> Lead Filters
            </span>
            <IoClose className={styles.closeBtn} onClick={onClose} />
          </div>

          {/* BODY */}
          <div className={styles.body}>
            {/* BASIC */}
            <div className={styles.section}>
              <p className={styles.sectionLabel}>Basic Info</p>
              <div className={styles.filterGrid}>
                <TextField
                  fullWidth
                  label="Mobile Number"
                  value={form.mobile_number || ""}
                  onChange={(e) => {
                    let val = e.target.value.replace(/\D/g, "");
                    if (val.length <= 10) handleChange("mobile_number", val);
                  }}
                  margin="dense"
                />
                <TextField
                  fullWidth
                  label="Name"
                  value={form.first_name || ""}
                  onChange={(e) => handleChange("first_name", e.target.value)}
                  margin="dense"
                />

                <Autocomplete
                  options={sources}
                  value={form.source}
                  onChange={(e, val) => handleChange("source", val)}
                  renderInput={(params) => (
                    <TextField {...params} label="Source" margin="dense" />
                  )}
                />

                {/* EXPERIENCE */}
                <Autocomplete
                  options={expOptions}
                  value={expType}
                  onChange={(e, selected) => {
                    setExpType(selected);
                    if (!selected) return;
                    if (selected.label === "Custom") {
                      setIsCustomExp(true);
                      handleChange("exp_from", null);
                      handleChange("exp_to", null);
                    } else {
                      setIsCustomExp(false);
                      handleChange("exp_from", selected.min);
                      handleChange("exp_to", selected.max);
                    }
                  }}
                  getOptionLabel={(opt) => opt.label}
                  renderInput={(params) => (
                    <TextField {...params} label="Experience" margin="dense" />
                  )}
                />
                {isCustomExp && (
                  <div className={styles.filterGrid}>
                    <TextField
                      fullWidth
                      label="Min Exp"
                      value={form.exp_from || ""}
                      onChange={(e) =>
                        handleChange(
                          "exp_from",
                          e.target.value.replace(/\D/g, ""),
                        )
                      }
                      margin="dense"
                    />
                    <TextField
                      fullWidth
                      label="Max Exp"
                      value={form.exp_to || ""}
                      onChange={(e) =>
                        handleChange(
                          "exp_to",
                          e.target.value.replace(/\D/g, ""),
                        )
                      }
                      margin="dense"
                    />
                  </div>
                )}
              </div>
            </div>
            <div className={styles.section}>
              <p className={styles.sectionLabel}>Job Category</p>

              {/* JOB CATEGORY — from options prop */}
              <Autocomplete
                multiple
                options={jobOptions}
                value={jobOptions.filter((opt) =>
                  (form.job_category || []).includes(opt.label),
                )}
                onChange={(e, val) =>
                  handleChange(
                    "job_category",
                    val.map((v) => v.label),
                  )
                }
                getOptionLabel={(opt) => opt.label}
                renderTags={(v, g) => renderTags(v, g, "job")}
                renderInput={(params) => (
                  <TextField {...params} label="Job Category" />
                )}
                sx={autoSX}
              />
            </div>

            {/* LOCATION + EXP */}
            <div className={styles.section}>
              <p className={styles.sectionLabel}>Location</p>
              <div className={styles.filterGrid}>
                {/* LOCATION — from options prop */}
                <Autocomplete
                  multiple
                  options={locationOptions}
                  value={locationOptions.filter((opt) =>
                    (form.pref_location || []).includes(opt.label),
                  )}
                  onChange={(e, val) =>
                    handleChange(
                      "pref_location",
                      val.map((v) => v.label),
                    )
                  }
                  getOptionLabel={(opt) => opt.label}
                  renderTags={(v, g) => renderTags(v, g, "location")}
                  renderInput={(params) => (
                    <TextField {...params} label="Preferred Location" />
                  )}
                  sx={autoSX}
                />

                {/* AREA — from options prop */}
                <Autocomplete
                  multiple
                  options={areaOptions}
                  value={areaOptions.filter((opt) =>
                    (form.pref_area || []).includes(opt.label),
                  )}
                  onChange={(e, val) =>
                    handleChange(
                      "pref_area",
                      val.map((v) => v.label),
                    )
                  }
                  getOptionLabel={(opt) => opt.label}
                  renderTags={(v, g) => renderTags(v, g, "area")}
                  renderInput={(params) => (
                    <TextField {...params} label="Preferred Area" />
                  )}
                  sx={autoSX}
                />
              </div>
            </div>

            {/* DATE */}
            <div className={styles.section}>
              <p className={styles.sectionLabel}>
                Lead Created Date & Sub Stage Date
              </p>
              <div className="mb-2" style={{ fontSize: "12px" }}>
                <b>Created Date</b>
              </div>
              <DateFilter
                value={{
                  date_from: form.created_from,
                  date_to: form.created_to,
                }}
                onChange={(dates) => {
                  handleChange("created_from", dates.date_from);
                  handleChange("created_to", dates.date_to);
                }}
              />
              <div style={{ marginTop: "10px" }}>
                <span style={{ fontSize: "12px" }}>
                  <b>Sub Stage Date and Reason</b>
                </span>
                <span className={styles.filterGrid}>
                  <span style={{ marginTop: "10px" }}>
                    <DateFilter
                      value={{
                        date_from: form.sub_stage_date_from,
                        date_to: form.sub_stage_date_to,
                      }}
                      onChange={(dates) => {
                        handleChange("sub_stage_date_from", dates.date_from);
                        handleChange("sub_stage_date_to", dates.date_to);
                      }}
                    />
                  </span>
                  <Autocomplete
                    fullWidth
                    options={reasonList}
                    getOptionLabel={(option) => option.name || ""}
                    value={selectedReason}
                    onChange={(_, value) => {
                      if (!value) {
                        setForm((prev) => ({
                          ...prev,
                          current_sub_stage_id: null,
                          current_stage_id: null,
                        }));
                        return;
                      }

                      // ✅ Special case: Not Interest (26)
                      if (value.id === 26) {
                        setForm((prev) => ({
                          ...prev,
                          current_stage_id: 26,
                          current_sub_stage_id: null,
                        }));
                      } else {
                        // ✅ Normal flow
                        setForm((prev) => ({
                          ...prev,
                          current_sub_stage_id: value.id,
                          current_stage_id: null,
                        }));
                      }
                    }}
                    className="mt-2"
                    isOptionEqualToValue={(opt, val) => opt.id === val.id}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Reason / Sub Stage"
                        fullWidth
                      />
                    )}
                  />
                </span>
              </div>
            </div>

            {/* STATUS */}
            <div className={styles.section}>
              <p className={styles.sectionLabel}>Lead Status</p>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!form.lead_deactive}
                    onChange={(e) =>
                      handleChange("lead_deactive", e.target.checked)
                    }
                    sx={{
                      color: "#169c50",
                      "&.Mui-checked": { color: "#169c50" },
                    }}
                  />
                }
                label="Show Deactivated Leads"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!form.alreadyRegister}
                    onChange={(e) =>
                      handleChange("alreadyRegister", e.target.checked)
                    }
                    sx={{
                      color: "#169c50",
                      "&.Mui-checked": { color: "#169c50" },
                    }}
                  />
                }
                label="Already Registered"
              />
            </div>

            {/* ASSIGN */}
            {(isSuperAdmin || isTeamLeader) && adminList.length > 0 && (
              <div className={styles.section}>
                <p className={styles.sectionLabel}>Assignment</p>
                <Autocomplete
                  options={assignOptions}
                  value={assignValueObj}
                  onChange={handleAssignChange}
                  getOptionLabel={(opt) => opt?.label || ""}
                  isOptionEqualToValue={(o, v) => o.value === v.value}
                  renderInput={(params) => (
                    <TextField {...params} label="Assign To" margin="dense" />
                  )}
                />
              </div>
            )}
          </div>

          {/* FOOTER */}
          <div className={styles.footer}>
            <button className={styles.resetBtn} onClick={handleReset}>
              Reset
            </button>
            <button className={styles.applyBtn} onClick={handleApply}>
              Apply Filters
            </button>
          </div>
        </div>
      </ModalContainer>
    </MyModal>
  );
};

export default LeadFilterOffcanvas;
